<!-- READONLY COTIZACION -->
<template>
  <div class="container">
    <h4 class="cardD">Validar cotización y pago</h4>

    <h4 class="cardD mt-1">Resumen de Documentos</h4>

    <table class="table table-bordered table-hover table-fixed">
      <thead class="">
        <tr>
          <th class="check-col">Cantidad</th>
          <th class="descripcion-col">Descripción</th>
          <th class="precio-unitario-col">Precio unitario</th>
          <th class="precio-col">Precio</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="doc in documentos_base" :key="doc.id">
          <td class="">{{ doc.copias_certificadas }}</td>
          <td class="">{{ doc.tipo }}</td>
          <td class="font-weight-bold precio-col-container">{{ formatCurrency(doc.totalPorCopia) }}</td>
          <td class="font-weight-bold precio-col-container">{{ formatCurrency(doc.totalDocumento) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="mt-2">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-3">
            <table class="table table-bordered table-hover">
              <tbody>
                <tr>
                  <td class="">Subtotal</td>
                  <td class="font-weight-bold precio-col-container">{{ formatCurrency(subtotal_documentos) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <h4 class="cardD" v-if="subtotal_extras > 0">Extras</h4>
    <div class="" v-if="subtotal_extras > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-unitario-col">Precio unitario</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="urgencia">
            <td class="">✓</td>
            <td class="">Urgencia</td>
            <td class="font-weight-bold precio-col-container">{{ precio_urgencia }}%</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(total_urgencia) }}</td>
          </tr>
          <tr v-if="cotejo.envio_domicilio">
            <td class="">✓</td>
            <td class="">Envío a Domicilio</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(500) }}</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(500) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-2" v-if="subtotal_extras > 0">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-3">
            <table class="table table-bordered table-hover">
              <tbody>
                <tr>
                  <td class="">Subtotal</td>
                  <td class="font-weight-bold precio-col-container">{{ formatCurrency(subtotal_extras) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <h4 class="cardD mt-3 font-weight-bold">Total</h4>
      <div class="mt-2">
        <div class="font-weight-bold total">
          <div>
            <p class="orange-text">{{ formatCurrency(total_previo_descuento) }}</p>
          </div>
        </div>
      </div>
    </div>

    <hr v-if="subtotal_descuento > 0" />
    <h4 class="cardD" v-if="subtotal_descuento > 0">Descuentos</h4>
    <div class="" v-if="subtotal_descuento > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Cantidad</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-unitario-col">Precio unitario</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="descuento_documentos > 0">
            <td class="">{{ documentos_base.length - 3 }}</td>
            <td class="">Número de Documentos</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(descuentoUnitarioDocumentos) }}</td>
            <td class="font-weight-bold precio-col-container">{{ formatCurrency(descuento_documentos * -1) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-2" v-if="subtotal_descuento > 0">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-3">
            <table class="table table-bordered table-hover">
              <tbody>
                <tr>
                  <td class="">Subtotal</td>
                  <td class="font-weight-bold precio-col-container">{{ formatCurrency(subtotal_descuento * -1) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <h4 class="cardD mt-1" v-if="cuponAplicado || nombreCuponDescuento">Cupones</h4>
    <div class="row" v-if="cuponAplicado || nombreCuponDescuento">
      <div class="col-md-6">
        <base-input
          type="text"
          label="Cupón aplicado"
          placeholder="Cupón de descuento"
          :disabled="true"
          v-model="nombreCuponDescuento"
        ></base-input>
      </div>
    </div>

    <div class="mt-3" v-if="total_post_descuento != total_previo_descuento">
      <h4 class="cardD mt-3 font-weight-bold">Total</h4>
      <div class="mt-2">
        <div class="font-weight-bold total">
          <div>
            <p class="orange-text">{{ formatCurrency(total_post_descuento) }}</p>
          </div>
        </div>
      </div>
    </div>

    <h4 class="cardD">Referencia</h4>
    <div class="row">
      <div class="col-md-6">
        <ValidationProvider
          name="referencia"
          rules="max:50"
          v-slot="{ errors }"
          :custom-messages="{ max: 'Máximo 50 caracteres' }"
        >
          <base-input
            :disabled="true"
            type="text"
            v-model="cotejo.referencia"
          ></base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <h4 class="cardD mt-4">Estado del pago</h4>
    <div class="row">
      <div class="col-md-4">
        <base-input
          :disabled="true"
          type="text"
          label="Pagado"
          :value="pagado ? 'Sí' : 'No'"
        ></base-input>
      </div>
      <div class="col-md-4">
        <base-input
          :disabled="true"
          type="text"
          label="Fecha de pago"
          :value="fecha_pago ? fecha_pago : 'Sin pagar'"
        ></base-input>
      </div>
      <div class="col-md-4">
        <base-input
          :disabled="true"
          type="text"
          label="Forma de pago"
          :value="forma_pago ? forma_pago : 'N/A'"
        ></base-input>
      </div>
    </div>

    <div class="row mt-4" v-for="clausula in cotejo.clausulas_confirmacion" :key="clausula.clausula_confirmacion_id">
      <div class="col-md-12 d-flex">
        <ValidationProvider
          :name="'clausula-confirmacion-' + clausula.clausula_confirmacion_id"
          :rules="{ required: { allowFalse: false } }"
          v-slot="{ errors }"
          :custom-messages="{ required: 'La confirmación es obligatoria' }"
        >
          <div style="display: flex">
            <b-form-checkbox
              class="orange"
              v-model="clausula.confirmado"
              :id="'checkbox-clausula-confirmacion-' + clausula.clausula_confirmacion_id"
              :disabled="true"
            >
              {{ clausula.contenido }}
            </b-form-checkbox>
          </div>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="mt-4">
      <div class="row">
        <div class="col-12">
          <b-button
            class="btn-fill orange-btn bottom2"
            size="m"
            @click="submitValidar"
            :disabled="isSubmitButtonDisabledComputed"
          >
            Validar
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CotizacionesApi } from "@/api";
import { formatCurrency } from "@/utils/number-utils";

export default {
  name: "CotizacionCopiasCertificadasInfoBase",

  props: {
    cotejo: { type: Object },
  },

  async created() {
    const id_cotizaciones = this.cotejo.id_cotizaciones;

    if (id_cotizaciones) {
      const cotizacion = await CotizacionesApi.detail(id_cotizaciones);

      this.cotejo.cotizacion = cotizacion;

      this.pagado = cotizacion.pagado;
      this.fecha_pago = cotizacion.fecha_pago ? cotizacion.fecha_pago.substring(0, 10) : null;
      this.forma_pago = cotizacion.forma_pago;

      let conceptos = cotizacion.conceptos;
      if (conceptos) {
        if (typeof conceptos === "string") {
          try {
            conceptos = JSON.parse(conceptos);
          } catch (e) {
            console.error("Error al parsear conceptos:", e);
          }
        }
        Object.assign(this.$data, conceptos);
      }
    }
  },

  data() {
    return {
      // Costos pre-calculados
      precio_monto_base: 0,
      precio_pagina_util: 0,
      precio_descuento_3er: 0,
      precio_urgencia: 0,

      // Cantidades
      documentos_base: [],
      paginas_totales: 0,
      descuento_documentos: 0,

      // Subtotales
      subtotal_documentos: 0,
      subtotal_extras: 0,
      subtotal_descuento: 0,

      // Extras
      urgencia: false,
      envioDomicilio: false,

      // Totales
      total_urgencia: 0,
      total_previo_descuento: 0,
      total_post_descuento: 0,

      cuponAplicado: false,
      nombreCuponDescuento: null,
      cuponTipo: null,
      cuponDescuento: 0,
      cuponId: null,
      costoTotalAntesCupon: 0,

      pagado: null,
      fecha_pago: null,
      forma_pago: null,
    };
  },

  computed: {
    isSubmitButtonDisabledComputed() {
      return this.cotejo.clausulas_confirmacion.some((c) => !c.confirmado);
    },
    descuentoUnitarioDocumentos() {
      if (this.documentos_base.length <= 3 || this.descuento_documentos <= 0) return 0;
      return (this.descuento_documentos / (this.documentos_base.length - 3)) * -1;
    },
  },

  methods: {
    formatCurrency,

    submitValidar() {
      this.$emit("allChecksPassed");
    },
  },
};
</script>

<style scoped>
.table-fixed {
  table-layout: fixed;
  width: 100%;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 8px;
  text-align: left;
}

.check-col {
  width: 10%;
}

.descripcion-col {
  width: 50%;
}

.precio-unitario-col {
  width: 20%;
}

.precio-col {
  width: 20%;
}

.precio-col-container {
  justify-content: flex-end;
}

.total {
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.orange-text {
  color: #ea640b;
}
</style>
